import React, { useContext, useCallback } from "react";
import { ModalContext } from "context/ModalContext";
import { api_srv } from "services";
import { show_toast } from "utils/helpers";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { request_payment_direct_quoation } from "services/apiSrv";
import * as Yup from "yup";

export default function PaymentModal({ onHide, systemQuotationRef }) {
  const { modalClose } = useContext(ModalContext);

  const validationSchema = Yup.object().shape({
    phoneNumber: Yup.string()
      .matches(/^\+?\d{10,14}$/, "Phone number must be valid (10-14 digits)")
      .required("Phone number is required"),
  });

  const handleSubmit = useCallback(
    async (values, { setSubmitting, resetForm }) => {
      try {
        // Normalize phone number: if it starts with '0', replace with '+254'
        let normalizedPhoneNumber = values.phoneNumber.trim();
        if (normalizedPhoneNumber.startsWith("0")) {
          normalizedPhoneNumber = "254" + normalizedPhoneNumber.slice(1);
        }

        console.log("Submitting payment with phone number:", normalizedPhoneNumber);
        const payload = {
          phoneNumber: normalizedPhoneNumber,
          systemQuotationRef,
        };
        const response = await (await api_srv).request_payment_direct_quoation(payload);
        console.log("Payment API response:", response);
        show_toast("Payment initiated successfully", "success");
        resetForm();
        modalClose();
        onHide?.();
      } catch (err) {
        console.error("Error initiating payment:", err.message, err.stack);
        show_toast(`Failed to initiate payment: ${err.message}`, "error");
      } finally {
        setSubmitting(false);
      }
    },
    [modalClose, onHide, systemQuotationRef]
  );

  return (
    <div className="container-fluid #py-4">
      <div className="card p-4">
        <h4 className="">Initiate Payment</h4>
        <Formik
          initialValues={{
            phoneNumber: "",
          }}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ isSubmitting, handleChange }) => (
            <Form className="needs-validation" noValidate>
              <div className="mb-3 py-4">
                <label htmlFor="phoneNumber" className="form-label">
                  Phone Number
                </label>
                <Field
                  name="phoneNumber"
                  type="text"
                  className="form-control form-control-sm"
                  placeholder="Enter phone number (e.g., 0712345678 or +254712345678)"
                  onChange={(e) => {
                    console.log("Phone Number changed to:", e.target.value);
                    handleChange(e);
                  }}
                />
                <ErrorMessage
                  name="phoneNumber"
                  component="div"
                  className="text-danger small mt-1"
                />
              </div>

              <div className="d-flex justify-content-start gap-3 mt-4">
                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="btn btn-primary btn-lg d-flex align-items-center"
                >
                  {isSubmitting ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm me-2"
                        role="status"
                        aria-hidden="true"
                      />
                      Processing...
                    </>
                  ) : (
                    "Initiate Payment"
                  )}
                </button>
                <button
                  type="button"
                  className="btn btn-outline-secondary btn-lg"
                  onClick={modalClose}
                >
                  Cancel
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
}